import { requestNetwork } from "@shared/api/external";

export const getNetwork = () => requestNetwork();
